/// <reference lib="dom" />
import * as d3 from "d3";
import { type Chart, type ChartLayer, CreateChart } from "../../core/chart.ts";
import { type ChartMode, EditorSize, ModeSize, ModeTheme, PadMargin } from "../../core/mode.ts";
import { GridLayer } from "../../layers/grid.ts";
import { RefLineLayer } from "../../layers/refLine.ts";
import { AxisLayer } from "../../layers/axis.ts";
import { HzTickFormat } from "../../utils/format.ts";
import type { ChartTheme } from "../../utils/theme.ts";

export const FrequencyDisplay = {
  fMin: 20,
  fMax: 20000,
  mMax: 1.5,
  qMin: 0.1,
  qMax: 10,
  ticks: [50, 100, 200, 500, 1000, 5000, 10000],
};

export const FrequencyEditorSize = EditorSize(12, 4);

export interface FrequencyChartOpts {
  mode: ChartMode;
  layers: ChartLayer[];
  theme?: ChartTheme;
}

export function CreateFrequencyChart(container: HTMLElement, opts: FrequencyChartOpts): Chart {
  const editor = opts.mode === "editor";
  const size = ModeSize(opts.mode, FrequencyEditorSize);
  return CreateChart(container, {
    width: size.width,
    height: size.height,
    margin: PadMargin(size.pad),
    x: d3.scaleLog().domain([FrequencyDisplay.fMin, FrequencyDisplay.fMax]),
    y: d3.scaleLinear().domain([0, FrequencyDisplay.mMax]),
    theme: ModeTheme(opts.mode, opts.theme),
    layers: [
      GridLayer({ axis: "x", values: FrequencyDisplay.ticks }),
      ...(editor ? [RefLineLayer({ axis: "y", value: 1 })] : []),
      ...opts.layers,
      ...(editor
        ? [AxisLayer({ side: "bottom", values: FrequencyDisplay.ticks, format: HzTickFormat })]
        : []),
    ],
  });
}

export function QScale(qMin = FrequencyDisplay.qMin, qMax = FrequencyDisplay.qMax) {
  return d3.scaleLog().domain([qMin, qMax]);
}
